import { useState, forwardRef } from "react";
import { useTranslation } from "react-i18next";
import classes from "./CustomInput.module.css";
import { EyeIcon, EyeOffIcon } from "lucide-react";
import Loader, { LOADER_SIZES } from "./Loader";

const PasswordInput = forwardRef(
  (
    {
      title,
      textAlign,
      thick,
      flex,
      errorText,
      onChange,
      readonly,
      loading = null,
      ...props
    },
    ref
  ) => {
    const { t } = useTranslation("general");
    const [showPassword, setShowPassword] = useState(false);
    const [isWritting, setIsWritting] = useState(() =>
      props.value ? true : false
    );

    const handleChange = (e) => {
      if (onChange) {
        onChange(e);
      }
      // render toggle button only when there's input
      setIsWritting(e.target.value.length > 0);
    };

    const togglePasswordVisibility = () => {
      setShowPassword((prev) => !prev);
    };

    const showError = !props.value && errorText;
    const disabled =
      props.value === "" || props.value === undefined || props.disabled;

    return (
      <div className={flex ? classes.inputContainer : ""}>
        {title && <label className={classes.label}>{title}</label>}
        {showError && <div className="error-message">{t(errorText)}</div>}
        <div className={classes.inputWrapper}>
          <input
            className={`${classes.textInput} ${thick ? classes.thick : ""}`}
            {...props}
            type={showPassword ? "text" : "password"}
            onChange={handleChange}
            readOnly={readonly}
            ref={ref}
            style={{
              paddingInlineEnd: isWritting ? "40px" : "16px",
              ...props.style,
            }}
          />
          {loading === true && (
            <div className={classes.loaderHolder}>
              <Loader size={LOADER_SIZES.XSMALL} withoutText />
            </div>
          )}
          {isWritting && !readonly && (
            <button
              type="button"
              className={"password-input-show-password"}
              onClick={togglePasswordVisibility}
              disabled={disabled}
              style={{
                cursor: disabled ? "default" : "pointer",
                opacity: disabled ? 0.5 : 1,
              }}
            >
              {showPassword && !disabled ? (
                <EyeIcon size={16} aria-hidden="true" />
              ) : (
                <EyeOffIcon size={16} aria-hidden="true" />
              )}
              <span className="sr-only">
                {showPassword ? t("hidePassword") : t("showPassword")}
              </span>
            </button>
          )}
        </div>
      </div>
    );
  }
);

PasswordInput.displayName = "PasswordInput";

export default PasswordInput;
